
import { LayoutList, Map } from 'lucide-react';
import { ViewMode } from '@/lib/types/ride-types';
import { useDjangoData } from '@/contexts/DjangoContext';

interface RideHubHeaderProps {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
}

const RideHubHeader = ({ viewMode, setViewMode }: RideHubHeaderProps) => {
  const { data } = useDjangoData();
  const logo = data.urls?.logo;

  const renderMapModeSelector = (viewMode: ViewMode) => {
    return (
        <button
          className={`p-2 rounded-md ${viewMode === 'map' ? 'bg-adv-orange text-white' : 'bg-adv-darkGray text-adv-lightGray hover:bg-adv-darkGray/70'}`}
          onClick={() => setViewMode('map')}
          aria-label="Map View"
          title="Map View"
        >
          <Map size={20} />
        </button>
    );
  }

  const renderListModeSelector = (viewMode: ViewMode) => {
    return (
      <button
        className={`p-2 rounded-md ${viewMode === 'list' ? 'bg-adv-orange text-white' : 'bg-adv-darkGray text-adv-lightGray hover:bg-adv-darkGray/70'}`}
        onClick={() => setViewMode('list')}
        aria-label="List View"
        title="List View"
      >
        <LayoutList size={20} />
      </button>
    );
  }
  
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start mb-4">
      <div className="flex items-center">
        <img 
          src={logo} 
          alt="Exodus ADV Logo" 
          className="h-10 mr-3 hidden sm:block" 
        />
        {(viewMode === 'map') ? (
          <h2 className="heading-lg text-adv-dark">Adventure Ride Map</h2>
        ): (
          <h2 className="heading-lg text-adv-dark">Adventure Ride List</h2>
        )}
      </div>
      <div className="flex space-x-2 mt-2 sm:mt-0">
        {renderMapModeSelector(viewMode)}
        {renderListModeSelector(viewMode)}
      </div>
    </div>
  );
};

export default RideHubHeader;
